import {Fragment} from 'react';
import {KeenIcon} from '@/components';
import {Container} from '@/components/container';
import {toAbsoluteUrl} from '@/utils';
import {CompanyDetailsData} from '@/pages/buddy/types/CompanyDetailsData.ts';

interface CompanyProfileHeroProps {
    company: CompanyDetailsData;
}

const CompanyProfileHero = ({company}: CompanyProfileHeroProps) => {
    return (
        <Fragment>
            <style>
                {`
                    .hero-bg {
                        background-image: url('${toAbsoluteUrl('/media/images/2600x1200/bg-1.png')}');
                    }
                    .dark .hero-bg {
                        background-image: url('${toAbsoluteUrl('/media/images/2600x1200/bg-1-dark.png')}');
                    }
                `}
            </style>
            <div className="bg-center bg-cover bg-no-repeat hero-bg">
                <Container>
                    <div className="flex flex-col items-center gap-2 lg:gap-3 py-4 lg:py-5">
                        <div
                            className="flex items-center justify-center rounded-full border-2 border-primary bg-light h-[100px] w-[100px]"
                        >
                            {company.image_url ? (
                                <img
                                    src={toAbsoluteUrl(company.image_url)}
                                    alt={company.name || 'Company image'}
                                    className="size-[50px] object-cover"
                                />
                            ) : (
                                <KeenIcon icon="home" className="default-color text-3xl"/>
                            )}
                        </div>

                        <div
                            className="text-2xl font-semibold text-gray-800 text-center">{company.name}</div>

                        {company.headquarters_address && (
                            <div className="flex items-center gap-1 text-gray-600 text-sm">
                                <KeenIcon icon="business" className="text-primary"/>
                                <span>{company.headquarters_address}</span>
                            </div>
                        )}

                    </div>
                </Container>
            </div>
        </Fragment>
    );
};

export {CompanyProfileHero};
